module.exports = __webpack_public_path__ + "img/xiaochengxu-lifehall.78b0fe85.png";